export default __webpack_public_path__ + "static/media/Eidolon-art.b451a226.png";